import type { AgentStatusLine as Line, Banner, MessageDescriptor } from "@bundle/core";
import { Icon, Stack, Text } from "../primitives/index.ts";
import { useTr } from "../i18n/I18nProvider.tsx";

/** "Honey: Working…" under the composer, one line per active agent. */
export function AgentStatusLine({ line }: { line: Line }) {
  const tr = useTr();
  return (
    <Stack direction="horizontal" align="center" gap="1.5" testID={`agent-status-${line.userId}`}>
      <Icon name={line.state === "error" ? "alert" : line.state === "waiting" ? "hourglass" : "sparkles"} size="icon.sm" color={line.state === "error" ? "status.danger" : "agent.fg"} />
      <Text variant="caption" weight="medium" color={line.state === "error" ? "status.danger" : "agent.fg"} lines={1}>
        {tr(line.label)}
      </Text>
    </Stack>
  );
}

/** "Ada is typing…" (reserved height so the layout doesn't jump). */
export function TypingIndicator({ label }: { label?: MessageDescriptor }) {
  const tr = useTr();
  return (
    <Stack direction="horizontal" align="center" testID="typing-indicator">
      <Text variant="caption" color="text.tertiary" lines={1}>
        {label === undefined ? " " : tr(label)}
      </Text>
    </Stack>
  );
}

/** Offline / reconnecting banner. */
export function ConnectivityBanner({ banner }: { banner: Banner }) {
  const tr = useTr();
  const warn = banner.tone === "warning";
  return (
    <Stack direction="horizontal" align="center" justify="center" gap="2" paddingY="1.5" paddingX="4" background={warn ? "mention.bg" : "bg.surface"} testID="connectivity-banner">
      <Icon name={warn ? "offline" : "reload"} size="icon.sm" color={warn ? "mention.fg" : "text.secondary"} />
      <Text variant="footnote" weight="medium" color={warn ? "mention.fg" : "text.secondary"}>
        {tr(banner.label)}
      </Text>
    </Stack>
  );
}
